<template>
  <div class="product">
    <header>
      <img src="../../assets/img/product5.png" alt="">
      <section class="tag">
        <img src="../../assets/img/product6.png" alt="">
      </section>
    </header>
    <main>
      <section class="title">
        <div class="gang"></div>
        <h1>阿启泰·书籍文献管理系统</h1>
        <h1>数据</h1>
      </section>
      <ul class="number">
        <li>
          <p>数字化书籍文献</p>
          <h3>1万多</h3>
          <p>本</p>
        </li>
        <li>
          <p>书籍文献marc信息</p>
          <h3>3-4万</h3>
          <p>条</p>
        </li>
        <li>
          <p>书籍文献分类</p>
          <h3>100多</h3>
          <p>个</p>
        </li>
        <li>
          <p>馆藏信
            <br>息</p>
          <h3>20多</h3>
          <p>地</p>
        </li>
      </ul>
      <section class="block">
        <div class="gang"></div>
        <h1>集群式书籍文献管理系统</h1>
        <p>
          集群式书籍文献管理系统通过书籍文献管理平台,实现RFID书籍管理系统、24小时自助书籍文献管理系统以及智能微型书籍文献管理系统，与各级书籍文献主管单位连接，实现管理端对辖区内所有书籍文献的单平台统一管理，建设书籍文献馆联合服务体系。</p>
        <img src="../../assets/img/product3.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>分布式书籍文献管理系统</h1>
        <p>分布式书籍文献管理系统将实现读者借书、还书、续借、预借、查询等基本服务功能。帮助管理员更方便轻松的管理书籍文献，以点带面让书香覆盖在城市每个角落。打通全民阅读“最后一公里”。</p>
        <img src="../../assets/img/product16.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>阿启泰书籍文献管理平台</h1>
        <p>阿启泰书籍文献管理平台有软件和硬件组成。</p>
        <img src="../../assets/img/product7.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>智能微型图书馆</h1>
        <p>智能微型图书馆是一种移动图书文献流动设备。它让书籍文献真正走进某一房间和楼层，解决了传统图书馆室内场地小、位置远、服务时间短的局限。
          它是传统图书馆的有益补充，具有借书、还书续借、预借、查询等基本服务功能,就是个小型的“移动图书馆”。</p>
        <img src="../../assets/img/product20.png" alt="">
        <img src="../../assets/img/product8.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>图书馆安全门</h1>
        <p>
          图书馆安全门是专为阿启泰图书馆设计的高性能防盗设备，此系列安全门采用RFID技术和三维全向感应设计，支持图书电子标签任意方向的检测;支持多种报警检测模式;除防盗功能外,亦支持对进出读者人次的双向统计，方便馆方随时了解图书馆进出馆的人流数量;同一系统可支持多片安全门并排安装使用。</p>
        <img src="../../assets/img/product9.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>读者证</h1>
        <ul>
          <li>每张读者证具有唯一序列号</li>
          <li>用于图书借还、检索、承载个人信息及借阅记录</li>
          <li>读者证具有较高的安全性，防止存储在读者证中的信息被泄露</li>
          <li>读者证每一面印制的内容可根据图书馆要求定制</li>
        </ul>
        <img src="../../assets/img/product10.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>升降式移动还书箱</h1>
        <ul>
          <li>根据负载自动升降结构，运行稳定可靠</li>
          <li>以电泳铝材为骨架，四周封板为铝塑纤维板</li>
          <li>脚轮采用超静音耐磨脚轮，运行时超低噪音</li>
          <li>平台升降高度:≤450mm</li>
          <li>装书容量:150L (可放80-200册)</li>
        </ul>
        <img src="../../assets/img/product11.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>自助借还书机</h1>
        <p>自助借还书机通过对粘贴有RFID标签的资料、书籍进行扫描、识别，将人工借还改为自助借还，提高了借阅服务质量。</p>
        <img src="../../assets/img/product12.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>升降式移动还书箱</h1>
        <ul>
          <li>RFID标签自带存储空间</li>
          <li>具有很好的防冲突性能</li>
          <li>具有多标签识别功能</li>
          <li>非接触式地读取和写入</li>
        </ul>
        <img src="../../assets/img/product13.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>分体式馆员工作站</h1>
        <p>馆员工作站是集成RFID读写装置、各种类型读者证识别装置、条形码识别装置于一体的设备,对RFID图书/档案标签进行编写、识别和流通状态处理,应用于标签转换以及图书人工借还环节。</p>
        <img src="../../assets/img/product4.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>蒙汉双语pc端管理系统</h1>
        <p>本系统采用B/S架构的重直管理模式，集图书流通管理设备管理、OPAC管理于一体，不仅实现了区域管理端对客户端的在线管理，而且实现了资源共享和建设图书馆联合服务体系。</p>
        <img src="../../assets/img/product15.jpg" alt="">
      </section>
      <section class="block">
        <div class="gang"></div>
        <h1>蒙汉双语手机端书籍文献库APP</h1>
        <p>移动端具备书籍文献管理的基本功能， 登录即可进行远程操作，方便管理员随时随地管理馆内的各个设备 。</p>
        <img src="../../assets/img/product2.jpg" alt="">
      </section>
      <section class="footer">
        <div class="gang"></div>
        <h1>阿启泰·书籍文献管理系统</h1>
        <h1>创新实践</h1>
        <section>
          <img src="../../assets/img/product18.png" alt="">
          <button>查看更多</button>
        </section>
        <section>
          <img src="../../assets/img/product17.png" alt="">
          <button>查看更多</button>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.product {
  width: 100%;
  padding: 4rem 0 0 0;
  height: 100%;

  header {
    width: 100%;
    background: url("../../assets/img/product1.png") no-repeat center center;
    background-size: cover;
    height: 16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    //padding: ;
    > img {
      width: 15.54rem;
      //width: 27.69rem;
    }

    .tag {
      //width: 1000px;
      width: 100%;
      //margin-top: 4rem;
      position: absolute;
      text-align: right;
      padding-right: 5%;
      bottom: 1rem;
      img {
        //display: none;
        cursor: pointer;
        width: 11.96rem;
      }
    }
  }

  main {
    width: 100%;
    background: white;
    overflow: hidden;

    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 2.69rem 0 1.15rem 0;
      padding: 0 10px;

      div {
        width: 3.08rem;
        height: 0.23rem;
        background: #26BFB9;
        margin-bottom: 1.42rem;
      }

      h1 {
        font-size: 1.2rem;
        line-height: 2rem;
        margin-bottom: 0.27rem;
        color: black;
      }

      h1:last-of-type {
        color: #1F3363;
        font-weight: 600;
        margin-bottom: 0;
      }
    }

    .number {
      display: flex;
      height: 6rem;
      margin-top: 39px;
      width: 100%;
      justify-content: center;
      //margin-bottom: 142px;
      //padding: 5px;
      li {
        background: linear-gradient(180deg, #FEFEFE 0%, #E3E3E3 100%);
        box-shadow: 0 5px 8px 0 #C8C8C8;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        flex-shrink: 0;

        p {
          width: 3.94rem;
          color: #333333;
          font-weight: bold;
          text-align: center;
          //height: 50px;
        }

        p:last-child {
          height: 20px;
        }

        h3 {
          color: #055AD9;
          font-size: 1.10rem;
        }
      }

      li:nth-child(1) {
        //margin-left: 1rem;
      }

      li:nth-child(2) {
        margin-left: -0.8rem;
      }

      li:nth-child(3) {
        margin-left: -0.8rem;
      }

      li:nth-child(4) {
        margin-left: -0.8rem;
      }
    }

    @media (min-width: 320px) {
      .number {
        li {
          width: 5.5rem;
          height: 5.5rem;
          p{
            font-size: 0.3px;
          }
          h3{
            font-size: 1.0rem;
          }
        }

      }
    }
    @media (min-width: 375px) {
      .number {
        li {
          width: 6rem;
          height: 6rem;
          p{
            font-size: 0.6rem;
          }
        }
      }
    }
    @media (min-width: 414px) {
      .number {
        li {
          width: 6.5rem;
          height: 6.5rem;
          p{
            font-size: 0.6rem;
          }
        }
      }
    }
    .block {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 2.69rem 0 1.15rem 0;
      padding: 0 10px;

      div {
        width: 3.08rem;
        height: 0.23rem;
        background: #26BFB9;
        margin-bottom: 1.42rem;
      }

      h1 {
        font-size: 1.2rem;
        line-height: 2rem;
        margin-bottom: 0.27rem;
      }

      p {
        color: #1F3363;
        font-weight: 500;
        margin-bottom: 0;
        line-height: 2rem;
        font-size: 1rem;
        text-align: justify;
      }

      img {
        width: 100%;
        margin-top: 2rem;
      }

      ul {
        li {
          list-style: disc inside;
          line-height: 2rem;
          font-size: 1rem;
          text-align: justify;
          margin-bottom: 0;
          font-weight: 500;
        }
      }
    }

    .footer {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 2.69rem 0 0 0;
      padding: 0 10px;

      div {
        width: 3.08rem;
        height: 0.23rem;
        background: #26BFB9;
        margin-bottom: 1.42rem;
      }

      h1 {
        font-size: 1.2rem;
        line-height: 2rem;
        margin-bottom: 0.27rem;
        color: black;
      }

      h1:last-of-type {
        color: #1F3363;
        font-weight: 700;
        margin-bottom: 0;
      }

      section {
        width: 100%;
        position: relative;
        margin-bottom: 1.19rem;
        border-radius: 5px;

        img {
          width: 100%;
          border-radius: 5px;
        }

        button {
          position: absolute;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          outline: none;
          border: none;
          width: 10.23rem;
          height: 2.46rem;
          background: #FFFFFF;
          color: #1B1E58;
          font-size: 0.69rem;
          border-radius: 0.19rem;
        }
      }
    }
  }
}


</style>
